/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React, { useEffect } from "react";
import { useMenus, Link } from "docz";

const Page = ({ children }) => {
  return (
    <SlideNavigation>
      <div
        css={css`
          position: absolute;
          top: 0px;
          left: 0px;
          width: 100%;
          height: 100%;
        `}
      >
        <div
          css={css`
            height: 100%;
            width: 100%;
            perspective: 1000px;
            transform-style: flat;
          `}
        >
          <div
            css={css`
              transform-origin: center center;
              position: absolute;
              top: 0px;
              left: 0px;
              width: 100%;
              height: 100%;
              display: flex;
              background-color: white;
              overflow: hidden;
            `}
          >
            <div
              css={css`
                display: flex;
                flex: 1 1 0%;
                justify-content: center;
                align-items: center;
              `}
            >
              <div
                css={css`
                  text-align: center;
                  max-height: 700px;
                  max-width: 1000px;
                  margin: 0 auto;
                  flex: 1 1 0%;
                `}
              >
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SlideNavigation>
  );
};

function NextOrPrevLink({ id, link, direction }) {
  let isLink = link ? true : false;
  let LinkOrNot = isLink ? Link : ({ children }) => <div>{children}</div>;
  let linkProps = isLink ? { id: id, key: link.id, to: link.route } : {};
  return (
    <LinkOrNot {...linkProps}>
      <svg
        css={css`
          width: 40px;
          height: 40px;
          transform: rotate(${direction === "right" ? 180 : 0}deg);
          opacity: ${isLink ? 1 : 0.3};
        `}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
      >
        <path d="M348,88.4c6.3-6.3,6.3-16.6,0-23c-6.3-6.3-16.6-6.3-23,0L152,238.5c-3,3-4.8,7.2-4.8,11.5s1.7,8.4,4.8,11.5L325,434.6 c3.2,3.2,7.3,4.8,11.5,4.8c4.2,0,8.3-1.6,11.5-4.8c6.3-6.3,6.3-16.6,0-23L186.6,250L348,88.4z" />
      </svg>
    </LinkOrNot>
  );
}

const getPrevAndNext = menus => {
  let pathname = window.location.pathname;
  let prevLink = null;
  let nextLink = null;
  menus.forEach((menu, index) => {
    if (menu.route === pathname) {
      if (index > 0) {
        prevLink = menus[index - 1];
      }
      if (index + 1 < menus.length) {
        nextLink = menus[index + 1];
      }
    }
  });
  return { prevLink, nextLink };
};

function SlideNavigation({ children }) {
  let menus = useMenus();
  let { prevLink, nextLink } = getPrevAndNext(menus);

  useEffect(() => {
    const onKeyDown = e => {
      // If we have prevented the default, ignore this.
      if (e && e.defaultPrevented) {
        return;
      }
      if (e.key === "Home") {
        // fn+ArrowLeft
        let prevLink = document.getElementById("PrevLink");
        prevLink && prevLink.click();
      }
      if (e.key === "End") {
        // fn+ArrowRight
        let nextLink = document.getElementById("NextLink");
        nextLink && nextLink.click();
      }
    };
    document.body.addEventListener("keydown", onKeyDown);
    return () => document.body.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <>
      {children}
      <div
        css={css`
          position: fixed;
          bottom: 110px;
          right: 10px;
          display: flex;
          flex-direction: column;
        `}
      >
        {menus.map(menu => (
          <Link
            key={menu.id}
            to={menu.route}
            css={css`
              width: 20px;
              height: 20px;
              background: #000;
              border-radius: 50%;
              transform: scale(0.7);
              opacity: 0.3;
              &:hover,
              &.active {
                transform: scale(1);
                opacity: 1;
              }
            `}
          />
        ))}
      </div>
      <div
        css={css`
          position: fixed;
          bottom: 10px;
          right: 0;
          display: flex;
          flex-direction: column;
        `}
      >
        <NextOrPrevLink id="PrevLink" link={prevLink} direction="left" />
        <NextOrPrevLink id="NextLink" link={nextLink} direction="right" />
      </div>
    </>
  );
}

export default Page;
